<template>
  <div class="courseList noSel">
	  <div class="cont">
      <div class="heade">
        <div class="search">
          <input type="text" v-model="searchKey" placeholder="搜索讲师/内容"><div class="search_btn" @click="search()"></div>
        </div>
        <div class="londBtn">
          <div class="btn" @click="isLond=true">下载客户端</div>
          <div class="dev">为了更好的体验，请下载客户端</div>
        </div>
        <div class="seWrap">
          <div class="lis" >
						<p>内容：</p>
						<ul>
							<li :class="{active:typeId==''}" @click="searchType('')">全部</li>
							<li v-for="(item,index) in types" :key="index" @click="searchType(item.id)" :class="{active:typeId==item.id}" >{{item.typeDescribe}}</li>
						</ul>
					</div>
          <div class="lis" >
						<p>讲师：</p>
						<ul>
							<li :class="{active:leturerId==''}" @click="searchLecturer('')">全部</li>
							<li v-for="(item,index) in lecturers" :key="index" @click="searchLecturer(item.id)" :class="{active:leturerId==item.id}">{{item.lecturerName}}</li>
						</ul>
					</div>
        </div>
        <div class="seList">
          <div class="se " :class="{active:collectType==''}" @click="page=1;collectType='';getCourseitem()">
            默认排序
          </div>
           <div class="se" :class="{active:collectType=='collection'}" @click="page=1;collectType='collection';getCourseitem()">
            我的收藏
          </div>
        </div>
      </div>
		  <div class="ul" v-if="list!=''">
        <div class="li" v-for="(item,index) in list" :key="index" @click="goLinks('/courseDetail?id='+item.id)">
          <div class="img">
            <img :src="item.coverPic?item.coverPic:require('../../../assets/images/course/course.png')" alt="">
          </div>
          <div class="co">
            <div class="name">
              {{item.title}}
            </div>
            <div class="tex">
              <div class="left" v-if="item.lecturer" >
                <img class="tx" v-if="item.lecturer.lecturerAvatarUrl"  :src="item.lecturer.lecturerAvatarUrl" alt="">
                <div class="tx" v-else></div>
                <div class="na" v-if="item.lecturer.lecturerName">{{item.lecturer.lecturerName}}</div>
                <div class="na" v-else>无</div>
              </div>
              <div class="right">
                <div class="aloneCont" v-if="item.feeType=='alone' &&item.oriState==0">
                   <div class="aloneTop" v-if="isStation">
                    <div class="vip">
                      <img src="../../../assets/images/vip.png" alt="">
                    </div>
                    <div class="originalPrice">
                      ￥<span>{{item.price}}</span>
                    </div>
                    <div class="prices">
                      ￥<span>{{item.originalPrice}}</span>
                    </div>
                  </div>
                  <div class="aloneTop avt" v-else >
                    <div class="original">
                      优惠价
                    </div>
                    <div class="originalPrice">
                      ￥<span>{{item.price}}</span>
                    </div>
                    <div class="prices">
                      ￥<span>{{item.originalPrice}}</span>
                    </div>
                  </div>
                  <div class="alonebottom" v-if="isStation">
                    <span>您已享受最高优惠</span>
                  </div>
                  <div class="alonebottom avts" v-else>
                    <div class="vip">
                      <img src="../../../assets/images/vip.png" alt="">
                    </div>  
                    <span>再享折上8.8折</span>
                  </div>
                
                </div>
                 <div class="rightCont" v-if="item.feeType=='alone' &&item.oriState==1">已购买</div>
                 <div class="rightCont" v-if="item.feeType=='alone' &&item.oriState==2">已兑换</div>
                <div class="rightCont" v-if="item.feeType=='charge'||item.feeType=='free'" :class="{avtrs:item.feeType=='charge'}">{{item.feeType=='free'?'免费':item.feeType=='charge'?'会员课程':'限时免费'}}</div>
                <!-- <div class="price" v-if="item.feeType!='free'">{{item.price==0?'':'￥'+item.price}}</div> -->
              </div>
            </div>
            <div class="dex">
              <div class="left" @click.stop="goChenk(item.collection,item.id)">
                <div class="ioc">
                  <img :src="item.collection?require('../../../assets/images/course/sc.png'):require('../../../assets/images/course/sc1.png')" alt="">
                </div>
                <div class="de">收藏</div>
              </div>
              <div class="right">共{{item.courseCount}}节课程 | {{item.learnCount}}人学习</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ul" v-else>
          <div class="noData">
            暂无数据
          </div>
      </div>
      <div class="pageWrap" v-if="list!=''">
        <div class="pages">
          <el-pagination
            :page-size="limit"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :total="pages.totalCount">
          </el-pagination>
        </div>
      </div>
	  </div>
    <Downloads :isLond="isLond" :londFun="londFun"></Downloads>
  </div>
</template>
<script>
import Downloads from '../../../components/Downloads/Index'
export default {
  name: "courseList",
  components: {
    Downloads
  },
  data: function() {
    return {
      isLond:false,
      type:'',
      limit:15,
      searchKey:'',
      collectType:'',
      page:1,
      list:[],
      typeId:'',
      leturerId:'',
      lecturers:[],
      types:[],
      pages:{},
      memberList:[],
      isStation:false,
      isCourse:false,
      isCase:false
    }
  },
  created(){
    this.getmember()
    this.getCourseitem()
    this.getcategory()
  },
   mounted () {
   },
   methods: {
      getmember(){
      this.$axios
      .get(this.interfaceJson.serverAddress+'/api/user/member')
      .then(res => {
        let data=res.data;
        if(data.code==0){
          this.memberList=data.data
          if(this.memberList.length!=0){
            this.memberList.forEach((item,i)=>{
              if(item.auth=="STATION"){
                this.isStation=true
              }
              if(item.auth=="COURSE"){
                this.isCourse=true
              }
              if(item.auth=="CASE"){
                this.isCase=true
              }
            })
          }
        }
      });
      },
     londFun(e){
       this.isLond= e
     },
      search(){
        this.page=1
        this.limit=15
        this.leturerId='';
        this.typeId='';
        this.getCourseitem();
      },
      searchType(e){
        this.typeId=e
         this.page=1
        this.limit=15
        this.getCourseitem()
      },
      searchLecturer(e){
        this.page=1
        this.limit=15
        this.leturerId=e
        this.getCourseitem()
      },
      getcategory(){
        this.$axios
          .get(this.interfaceJson.serverAddress+"/api/course/category")
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.lecturers=data.lecturers;
            this.types=data.types
          }
        });
      },
      getCourseitem(){
        this.$axios
          .get(this.interfaceJson.serverAddress+"/api/course/list?type="+this.type+'&page='+this.page+'&limit='+this.limit+'&key='+this.searchKey+'&leturerId='+this.leturerId+'&typeId='+this.typeId+'&collectType='+this.collectType)
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.pages=data.page
            this.list= data.page.list
          }
        });
      },
      goChenk(e,id){
        let url=''
        if(e){
          url= '/api/course/unCollection/'
        }else{
          url= '/api/course/collection/'
        }
        this.$axios
          .post(this.interfaceJson.serverAddress+url+id)
          .then(res => {
          let data=res.data;
          if(data.code==0){
            this.getCourseitem()
          }else{
          }
          });
      },
      handleCurrentChange(val) {
        this.page=val
        this.getCourseitem()
        }
   },
   
};
</script>
<style lang="scss" scoped>
.avtrs{
	color: #BD8D63 !important;;
}
.courseList{
	.cont{
		max-width: 1358px;
    margin: 0 auto;
    .heade{
      position: relative;
      padding-top: 27px;
      .londBtn{
         position: absolute;
          right:25px;
          top: 60px;
          .btn{
            width: 120px;
            height: 25px;
            background-color: #FBCA61;
            line-height: 25px;
            text-align: center;
            border-radius: 15px;
            cursor: pointer;
            margin: 0 auto 3px;
          }
          .btn:hover{
            color: #ffffff;
          }
          .dev{
            font-size: 12px;
            color: #666666;
          }
      }
      .search{
        width: 222px;
        height: 27px;
        position: absolute;
        right: 0;
        border-radius: 14px;
        border: 1px solid #DCDCDC;
        display: flex;
        align-items: center;
        top: 18px;
        input{
          border: 0;
          width: 172px;
          outline: none;
          margin-left: 18px;
          height: 100%;
          border-radius: 14px;
          font-size: 12px;
          background-color: #ffffff;
        }
        .search_btn{
          width: 12px;
          height: 12px;
          background: url('../../../assets/images/search_btn.png') no-repeat;
          background-size: 100%;
          cursor: pointer;
        }
      }
      .seList{
        display: flex;
        width: 806px;
        margin: 12px auto 0;
        .se{
          font-size: 12px;
          color: #333333;
          margin-right: 40px;
          cursor: pointer;
        }
        .active{
          font-size: 12px;
          color: #178AFF;
        }
      }
      .seWrap{
        width: 806px;
        padding-bottom: 12px;
        margin: 0 auto;
        border-bottom: 1px solid #E1E1E2;
        .lis{
          display: flex;
          margin-bottom: 13px;
          p{
            color: #333333;
            font-size: 12px;
            font-weight: bold;
          }
          ul{
            display: flex;
            flex-wrap: wrap;
            width: 760px;
            .active{
              padding:1px 5px;
              background-color: #929193;
              color: #FAFAFA;
            }
            li{
              margin-bottom: 12px;
              color: #666666;
              font-size: 12px;
              margin-right:25px;
              cursor: pointer;
              position: relative;
            }
            li::after{
              content:'';
              position: absolute;
              right: -12.8px;
              top: 0;
              height: 12px;
              width: 1px;
              background-color: #E1E1E2;
            }
            li:last-of-type:after{
              display: none;
            }
          }
        }
      }
    }
    .pageWrap{
      text-align: center;
      margin-bottom: 20px;
      .pages{
        display: inline-block;
      }
    }
    .ul{
      padding-top: 19px;
      display: flex;
      flex-wrap: wrap;
      .noData{
        font-size: 18px;
        text-align: center;
        line-height:333px;
        width: 100%;
      }
      .li{
        background-color: #FFFFFF;
        max-width: 254px;
        margin-bottom: 29px;
        margin-right: 22px;
        cursor: pointer;
        .img{
          img{
            width:254px;
            height:165px;
            margin: 0 auto;
          }
        }
        .co{
          padding: 13px 10px 11px 14px;
          .name{
            font-size: 14px;
            color: #333333;
            line-height: 17px;
            height: 34px;
          }
          .tex{
            display: flex;
            justify-content:space-between;
            margin-top: 12px;
            align-items: center;
            .left{
              display: flex;
              .tx{
                width: 30px;
                height: 30px;
                background: #EEEEEE;
                border: 1px solid #707070;
                border-radius: 50%;
              }
              .na{
                color: #333;
                font-size: 12px;
                line-height: 30px;
                margin-left: 5px;
              }
            }
            .right{
              line-height: 30px;
              color: #4A9F64;
              font-size: 12px;
              .rightCont{
                height: 20px;
                line-height: 16px;
              }
              .aloneCont{
                .aloneTop{
                  display: flex;
                  height: 17px;
                  align-items: center;
                  margin-bottom: 5px;
                  .vip{
                    width: 40px;
                    height: 12px;
                    background-color: #000;
                    border-radius: 25px;
                    text-align: center;
                    img{
                      vertical-align: top;
                      width: 30.5px;
                      height: 8px;
                      margin-top: 2px;
                    }
                  }
                  .originalPrice{
                    font-size: 12px;
                    color: #CBA95C;
                    span{
                      font-size: 16px;
                      color: #CBA95C;
                    }
                  }
                  .prices{
                    font-size: 12px;
                    color: #999999;
                    text-decoration:line-through
                  }
                }
                .avt{
                  .original{
                    color: #333333;
                    font-size: 13px;
                  }
                  .originalPrice{
                    font-size: 12px;
                    color: #F40101;
                    span{
                      font-size: 16px;
                      color: #F40101;
                    }
                  }
                }
                .alonebottom{
                  display: flex;
                  height: 12px;
                  line-height: 12px;
                  text-align: right;
                  justify-content: space-evenly;
                  span{
                     color: #333333;
                     font-size: 12px;
                     text-align: right;
                  }
                }
                .avts{
                  .vip{
                    width: 40px;
                    height: 12px;
                    background-color: #000;
                    border-radius: 25px;
                    text-align: center;
                    img{
                      vertical-align: top;
                      width: 30.5px;
                      height: 8px;
                      margin-top: 2px;
                    }
                  }
                   span{
                     margin-left: 3px;
                     color: #CBA95C;
                     font-size: 12px;
                     text-align: right;
                  }
                }
              }
              .price{
                color: #666666;
                font-size:14px ;
                height: 30px;
                text-align: center;
                text-decoration: line-through;
              }
            }
          }
          .dex{
            display: flex;
            justify-content:space-between;
            margin-top: 16px;
            .left{
              display: flex;
              cursor: pointer;
              .ioc{
                line-height: 17px;
                img{
                  width: 11px;
                  height: 11px;
                }
              }
              .de{
                color: #666666;
                font-size: 12px;
                line-height: 19px;
                margin-left: 3px;
              }
            }
            .right{
              color: #929193;
              font-size: 12px;
              line-height: 17px;
            }
          }
        }
      }
       .li:nth-child(5n){
         margin-right: 0;
       }
      .li:hover{
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      }
    }
	}
}

</style>
